export default function QuoteBand() {
  return (
    <section className="relative overflow-hidden bg-primary-600 text-background-50">
      <div className="mx-auto flex max-w-7xl flex-col items-center px-4 py-9 text-center md:px-6">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-[11px] font-semibold tracking-wide text-background-50/90 backdrop-blur">
          <i className="ri-quill-pen-line" />
          编辑部手记 · 抢鲜说明
        </span>
        <p className="mt-4 max-w-3xl font-heading text-lg font-bold leading-relaxed md:text-xl">
          “未经证实的不叫内幕，未经核验的不叫真相。98爆料只发布
          <span className="text-accent-300">经过双重信源交叉</span>
          的线索，把别处看不到的第一手材料，抢先递到你面前。”
        </p>
        <div className="mt-5 flex flex-wrap items-center gap-2 text-xs text-background-50/80">
          <span className="inline-flex items-center gap-1">
            <i className="ri-check-double-line text-accent-300" /> 今日已核验 17 条
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line text-accent-300" /> 追踪 3.1w 条讨论
          </span>
        </div>
      </div>
    </section>
  );
}